import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0983c8bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "box auth-box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "animate" }, "Volver a inicio.", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "animate" }, "Olvidé mi contraseña.", -1))

import { ref } from 'vue'
import LoginForm from '@/components/auth/LoginForm.vue'
import RegisterForm from '@/components/auth/RegisterForm.vue'
import main from '@/data/main.js';



export default /*#__PURE__*/_defineComponent({
  __name: 'AuthView',
  setup(__props) {

const showLogin = ref(true)

const toggleShowLogin = () => showLogin.value = !showLogin.value

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (showLogin.value)
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(main).LOGO_URI,
          class: "logo"
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (showLogin.value)
        ? (_openBlock(), _createBlock(LoginForm, { key: 0 }))
        : (_openBlock(), _createBlock(RegisterForm, { key: 1 })),
      _createElementVNode("footer", null, [
        (showLogin.value)
          ? (_openBlock(), _createElementBlock("small", {
              key: 0,
              onClick: toggleShowLogin,
              class: "animate"
            }, "Aún no tengo cuenta, registrarme."))
          : (_openBlock(), _createElementBlock("small", {
              key: 1,
              onClick: toggleShowLogin,
              class: "animate"
            }, "Ya tengo cuenta, acceder.")),
        _createVNode(_component_router_link, {
          to: {name: 'home'},
          class: "animate no-underscore"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(_component_router_link, {
          to: {name: 'recovery'},
          class: "animate no-underscore"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})